import { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2350FA',
    colorSuccess: '#17C82F',
    colorWarning: '#FFB020',
    colorError: '#FC3353',
    colorInfo: '#1890ff',
    colorLink: '#1DA57A',
    colorText: '#1F2733',
    colorBgSpotlight: 'rgba(31,39,51,0.7)',
    colorBgMask: 'rgba(31,39,51,0.8)',
    borderRadiusLG: 12,
    borderRadius: 6,
    fontSize: 14,
    wireframe: false,
  },
  components: {
    Button: {
      iconGap: 4,
      defaultHoverBg: '#fff',
      controlItemBgActiveHover: '#2350FA',
      borderColorDisabled: '#D5D9E0',
      colorTextDisabled: '#FFFFFF',
      defaultBorderColor: '#D5D9E0',
      defaultColor: '#3D4E66',
      defaultHoverBorderColor: '#2350FA',
      defaultHoverColor: '#2350FA',
      primaryColor: '#fff',
      borderRadius: 16,
      defaultShadow: 'none',
      primaryShadow: 'none',
      dangerShadow: 'none',
      paddingInline: 12,
      contentFontSize: 14,
      contentFontSizeSM: 12,
      colorLink: '#2350FA',
      borderRadiusLG: 22,
      paddingInlineLG: 16,
      algorithm: true, // 启用算法
    },
    Input: {
      colorPrimary: '#2350FA',
      colorTextPlaceholder: '#828FA2',
      colorBorder: '#D5D9E0',
      borderRadius: 6,
      borderRadiusLG: 6,
      colorBgContainerDisabled: '#F8F9FB',
      colorTextDisabled: '#828FA2',
      algorithm: true,
    },
    Select: {
      colorPrimary: '#2350FA',
      algorithm: true,
      optionSelectedColor: '#2350FA',
      optionSelectedBg: '#fff',
      optionActiveBg: '#f8f9fb',
      optionHeight: 28,
      colorTextPlaceholder: '#828FA2',
      fontSize: 14,
      optionFontSize: 14,
    },
    Menu: {
      colorPrimary: '#3D4E66',
      itemSelectedBg: 'transparent',
      itemSelectedColor: '#1F2733',
      itemHoverBg: '#D5D9E0',
      itemActiveBg: '#D5D9E0',
      algorithm: true,
    },
    Table: {
      colorPrimary: '#2350FA',
      stickyScrollBarBg: '#D5D9E0',
      stickyScrollBarBorderRadius: 2,
      algorithm: true,
    },
    Skeleton: {
      blockRadius: 0,
      gradientFromColor: 'rgba(130, 143, 162, 0.12)',
      gradientToColor: 'rgba(244, 244, 244, 0)',
      paragraphLiHeight: 32,
      titleHeight: 32,
      paragraphMarginTop: 32,
    },
    Modal: {
      headerBg: '#F2F8FC',
      titleLineHeight: '56px',
    },
    Upload: {
      colorPrimary: '#2350FA',
      colorBorder: '#D5D9E0',
      borderRadiusLG: 6,
      colorBgMask: 'rgba(0,0,0,0.5)',
      algorithm: true,
    },
    Cascader: {
      optionSelectedColor: '#2350FA',
      optionSelectedBg: '#F8F9FB',
      colorSplit: '#D5D9E0',
      colorText: '#1F2733',
      dropdownHeight: 180,
      controlItemWidth: 143,
    },
    Switch: {
      colorPrimary: '#2350FA',
      trackHeight: '24px',
      trackPadding: 3,
      colorTextQuaternary: '#D5D9E0',
      algorithm: true,
    },
    DatePicker: {
      colorPrimary: '#2350FA',
      activeBorderColor: '#2350FA',
      algorithm: true,
    },
    Tooltip: {
      colorBgSpotlight: 'rgba(31,39,51,0.7)',
      zIndexPopupBase: 1000,
      zIndexBase: 1000,
      algorithm: true,
    },
    Tree: {
      indentSize: 16,
      algorithm: true,
    },
  },
};
